import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Box } from '@mui/material'
import { SkillBiteEditSlice } from '../../../reducers'
import SessionSelector from './components/session-selector'
import PagePreview from './components/page-preview'
import { appFooterContainerId } from '../../../layouts/primary-layout'
import { EmptyIndicatorMessage } from '../build/components/empty-indicator'

const Preview = () => {
  const skillBite = useSelector(SkillBiteEditSlice.selectors.selectSkillBite)
  const { sessions } = skillBite

  useEffect(() => {
    document.getElementById(appFooterContainerId).style.display = 'none'
    return () => {
      document.getElementById(appFooterContainerId).style.display = 'block'
    }
  }, [])

  if (!sessions?.length) {
    return (
      <EmptyIndicatorMessage
        title='No sessions yet'
        subtitle='You can create sessions on the Build tab'
      />
    )
  }

  return (
    <Box display='flex' flexDirection='row' sx={{ padding: '16px' }}>
      <Box sx={{ width: '30%' }}>
        <SessionSelector sessions={sessions} />
      </Box>
      <Box display='flex' flexDirection='column' sx={{ flex: 1, p: 2, pr: 0, overflow: 'hidden' }}>
        <PagePreview />
      </Box>
    </Box>
  )
}

export default Preview
